export function measures(state, data) {
  state.measures = data
}

export function cycleTypes(state, data) {
  state.cycleTypes = data
}

export function cycleSegments(state, data) {
  state.cycleSegments = data
}

export function cycleBeads(state, data) {
  state.cycleBeads = data
}
